import { render, staticRenderFns } from "./invited-users.vue?vue&type=template&id=0b4e1e25&"
import script from "./invited-users.vue?vue&type=script&lang=ts&"
export * from "./invited-users.vue?vue&type=script&lang=ts&"
import style0 from "./invited-users.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports